//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormGroup from "@/0/components/comForm/comFormEditGroupViewX";
export default {
  name:"comFormEditTab",
  props: ["controlItem"],
  components: {
    "form-group": FormGroup,
  },
  data() {
    return {

    };
  },
  created() {
    console.log("comFormEditTab-created");
  },

  methods: {
    async onTabPageChange(tabPageId, title) {
      console.log("onTabPageChange-name", title);
    },

    $getSubmitData(initSubmitData) {
      //将表单数据处理后返回
      var submitData = {};
      if(initSubmitData){
        submitData = Object.assign(submitData,initSubmitData);
      }

      if(!this.controlItem.TabPageList || this.controlItem.TabPageList.length == 0){
        return submitData;
      }

      var groupSubmitList = {};
      this.controlItem.TabPageList.forEach(m => {
        var thisView = this.$refs['comView_' + m.OpenId];
        if(thisView && thisView.length > 0){
          thisView = thisView[0];
        }
        if(!thisView) return null;
        var thisSubmit = thisView.$getSubmitData();
        console.log("TabPageList--thisSubmit",thisSubmit);      
        groupSubmitList = Object.assign(groupSubmitList, thisSubmit);
      });

      if(groupSubmitList){
        submitData = Object.assign(submitData,groupSubmitList);
      }
      return submitData;

    }
  }
};
